module.exports = __webpack_public_path__ + "img/question.8074a34e.svg";